import moment from 'moment';
import nl from 'moment/locale/nl';

moment.updateLocale('nl', nl);


export const toFormattedDate = (d) => {
  // Formats date to what the backend expects (and makes it timezone naive);
  if (d) {
    return `${d.getFullYear()}-${(`0${d.getMonth() + 1}`).slice(-2)}-${(`0${d.getDate()}`).slice(-2)}`;
  }
  return null;
};

export const toFormattedDateTime = (d) => {
  // Formats date to what the backend expects (and makes it timezone naive);
  if (d) {
    return `${toFormattedDate(d)}T${(`0${d.getHours()}`).slice(-2)}:${(`0${d.getMinutes()}`).slice(-2)}:${(`0${d.getSeconds()}`).slice(-2)}`;
  }
  return null;
};

export const toPrettyDate = (d) => {
  const month = moment(d).format('MMM').toLowerCase();
  return `${d.getDate()} ${month} ${d.getFullYear()}`;
};

export const toPrettyDateTime = (d, includeSeconds) => {
  const month = moment(d).format('MMM').toLowerCase();
  let formattedDateTime = `${d.getDate()} ${month} ${d.getFullYear()} ${d.getHours()}:${(`0${d.getMinutes()}`).slice(-2)}`;
  if (includeSeconds) {
    formattedDateTime += `:${(`0${d.getSeconds()}`).slice(-2)}`;
  }
  return formattedDateTime;
};

export const toLocalPrettyDateTime = (d, locale) => (
  moment(String(d)).locale(locale || 'NL').format('LLL')
);

export const stringToPrettyDate = (dString) => {
  const d = new Date(dString);
  return toPrettyDate(d);
};

export const stringToPrettyDateTime = (dString, includeSeconds) => {
  const d = new Date(dString);
  return toPrettyDateTime(d, includeSeconds);
};

export const toPrettyMonthDate = (d) => {
  const month = moment(d).format('MMM').toLowerCase();
  return `${month} ${d.getFullYear()}`;
};

export const stringToPrettyMonthDate = (dString) => {
  const d = new Date(dString);
  return toPrettyMonthDate(d);
};

export const toPrettyPrice = (floatPrice) => {
  if (floatPrice) {
    return `€ ${String(parseFloat(floatPrice).toFixed(2))}`;
  }
  return `€ ${String(parseFloat('0.0').toFixed(2))}`;
};

export const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);
